module.exports = __webpack_public_path__ + "static/media/large-logo-dark.706cac39.svg";